import React, { useEffect } from 'react';
import { loadScript } from 'helpers';
import './index.scss';

const Footer = () => {
    useEffect(() => {
        (async () => {
            if (window.wgCommonSdk) return;

            await loadScript('//wg.360.cn/wgCommonSdk.min.js');
            window.wgCommonSdk.wgFoot({ root: '.footer_wrap' });
        })();
    }, []);

    return <div className="footer_wrap" />;
};

export default Footer;
